import React, { useEffect, useState, useRef } from 'react';
import { Plus, Pencil, Trash2, X, Check, Upload } from 'lucide-react';
import { projetoService } from '../../services/api';
import toast from 'react-hot-toast';

const STATUS = ['planejado','em andamento','concluido','suspenso'];

export default function AdminProjetos() {
  const [items,   setItems]   = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState<'criar'|'editar'|null>(null);
  const [current, setCurrent] = useState<any>(null);
  const [saving,  setSaving]  = useState(false);
  const [form, setForm] = useState({ titulo:'', descricao:'', categoria:'', status:'em andamento', beneficiados:'', parceiros:'' });
  const [imgFile, setImgFile] = useState<File|null>(null);
  const [imgPrev, setImgPrev] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);

  const load = () => { setLoading(true); projetoService.listar().then(r => setItems(Array.isArray(r.data) ? r.data : r.data.projetos||[])).catch(() => toast.error('Erro')).finally(() => setLoading(false)); };
  useEffect(load,[]);

  const openCriar = () => { setForm({ titulo:'',descricao:'',categoria:'',status:'em andamento',beneficiados:'',parceiros:'' }); setImgFile(null);setImgPrev('');setCurrent(null);setModal('criar'); };
  const openEditar = (item:any) => { setForm({ titulo:item.titulo,descricao:item.descricao||'',categoria:item.categoria||'',status:item.status||'em andamento',beneficiados:item.beneficiados||'',parceiros:item.parceiros||'' }); setImgPrev(item.imagemUrl||'');setImgFile(null);setCurrent(item);setModal('editar'); };
  const onChange = (e:any) => setForm(f=>({...f,[e.target.name]:e.target.value}));
  const onFile = (e:any) => { const f=e.target.files?.[0]; if(f){setImgFile(f);setImgPrev(URL.createObjectURL(f));} };

  const salvar = async () => {
    setSaving(true);
    try {
      const fd=new FormData(); Object.entries(form).forEach(([k,v])=>fd.append(k,v as string));
      if(imgFile) fd.append('imagem',imgFile);
      if(modal==='criar') await projetoService.criar(fd); else await projetoService.atualizar(current._id,fd);
      toast.success('Salvo!'); setModal(null); load();
    } catch { toast.error('Erro ao salvar.'); } finally { setSaving(false); }
  };

  const deletar = async (id:string) => { if(!window.confirm('Excluir?')) return; try { await projetoService.deletar(id); toast.success('Excluído!'); load(); } catch { toast.error('Erro.'); } };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Projetos</h1>
        <button className="btn btn-primary" onClick={openCriar}><Plus size={17}/> Novo projeto</button>
      </div>
      {loading ? <div className="loading-center"><div className="spinner"/></div> : (
        <div style={{ overflowX:'auto' }}>
          <table className="admin-table">
            <thead><tr><th>Imagem</th><th>Título</th><th>Categoria</th><th>Status</th><th>Ações</th></tr></thead>
            <tbody>
              {items.length===0 && <tr><td colSpan={5} style={{textAlign:'center',padding:32,color:'var(--texto-leve)'}}>Nenhum projeto.</td></tr>}
              {items.map(item=>(
                <tr key={item._id}>
                  <td>{item.imagemUrl?<img src={item.imagemUrl} alt="" style={{width:52,height:40,objectFit:'cover',borderRadius:6}}/>:<div style={{width:52,height:40,background:'var(--creme-escuro)',borderRadius:6}}/>}</td>
                  <td style={{fontWeight:600,fontSize:'0.9rem'}}>{item.titulo}</td>
                  <td>{item.categoria&&<span className="badge badge-turquesa">{item.categoria}</span>}</td>
                  <td><span className="badge badge-amarelo">{item.status}</span></td>
                  <td><div className="actions">
                    <button className="btn btn-outline btn-sm" onClick={()=>openEditar(item)}><Pencil size={14}/></button>
                    <button className="btn btn-sm" style={{background:'#fee2e2',color:'#b91c1c',borderRadius:'var(--radius)'}} onClick={()=>deletar(item._id)}><Trash2 size={14}/></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {modal&&(
        <div className="admin-modal-overlay" onClick={()=>setModal(null)}>
          <div className="admin-modal" onClick={e=>e.stopPropagation()}>
            <div className="admin-modal-header"><h3>{modal==='criar'?'Novo Projeto':'Editar Projeto'}</h3><button className="modal-close" onClick={()=>setModal(null)}><X size={20}/></button></div>
            <div className="admin-modal-body">
              <div className="form-group">
                <label className="form-label">Imagem</label>
                <div className="img-upload-area" onClick={()=>fileRef.current?.click()}>
                  {imgPrev?<img src={imgPrev} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'var(--radius)'}}/>:<div className="img-upload-placeholder"><Upload size={24}/><span>Clique para enviar</span></div>}
                </div>
                <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={onFile}/>
              </div>
              <div className="form-row-2">
                <div className="form-group"><label className="form-label">Título *</label><input name="titulo" value={form.titulo} onChange={onChange} className="form-control" required/></div>
                <div className="form-group"><label className="form-label">Categoria</label><input name="categoria" value={form.categoria} onChange={onChange} className="form-control" placeholder="saude, educação…"/></div>
              </div>
              <div className="form-group"><label className="form-label">Descrição *</label><textarea name="descricao" value={form.descricao} onChange={onChange} className="form-control" rows={4}/></div>
              <div className="form-row-2">
                <div className="form-group"><label className="form-label">Status</label><select name="status" value={form.status} onChange={onChange} className="form-control">{STATUS.map(s=><option key={s} value={s}>{s}</option>)}</select></div>
                <div className="form-group"><label className="form-label">Beneficiados</label><input name="beneficiados" value={form.beneficiados} onChange={onChange} className="form-control" placeholder="Ex: 100"/></div>
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={saving}>{saving?'Salvando…':<><Check size={16}/> Salvar</>}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}